export default __webpack_public_path__ + "static/media/Paladin's Widowmaker.fe50bd61.jpg";